(function () {
    'use strict';

    angular.module('blocks.notifications', []);
})();
